import React, { useState } from 'react'

const Nav = () => {
  const [referido, setReferido] = useState(localStorage.getItem('referedCode'))
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  return (
    <nav>
    <a href="https://chatby.io">
      <svg
        width="155"
        height="48"
        viewBox="0 0 155 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="nav__logo"
      >
        <g clip-path="url(#clip0_1_105)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.5537 5.82437C11.4991 5.82437 9.52847 6.64183 8.07603 8.09792C6.62358 9.55402 5.80613 11.5283 5.80613 13.5902V16.8053C8.06508 15.2288 10.762 14.3675 13.5501 14.3675H22.845V5.82437H13.5501H13.5537ZM0.00729872 28.3482C0.105831 31.8114 1.52178 35.1141 3.9705 37.5701C6.5141 40.121 9.9591 41.5516 13.5537 41.5516H21.3706V35.7272H13.5537C11.4991 35.7272 9.52847 34.9098 8.07603 33.4537C6.62358 31.9976 5.80613 30.0233 5.80613 27.9614C5.80613 25.8995 6.62358 23.9252 8.07603 22.4691C9.52847 21.013 11.4991 20.1955 13.5537 20.1955H28.6584V0H13.5537C9.9591 0 6.51045 1.43055 3.9705 3.98145C1.4269 6.5287 0 9.98829 0 13.5902V28.3482H0.00729872Z"
            fill="url(#paint0_linear_1_105)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M30.8626 42.2742C32.9172 42.2742 34.8879 41.4713 36.3403 40.0371C37.7928 38.6065 38.6102 36.6651 38.6102 34.6397V31.4794C36.3549 33.0267 33.6544 33.8733 30.8663 33.8733H21.5714V42.2705H30.8663L30.8626 42.2742ZM44.4127 20.1371C44.3142 16.7323 42.8982 13.488 40.4495 11.0721C37.9095 8.56869 34.4609 7.16003 30.8663 7.16003H23.0494V12.8859H30.8663C32.9209 12.8859 34.8915 13.6887 36.344 15.1229C37.7964 16.5535 38.6139 18.4949 38.6139 20.5203C38.6139 22.5457 37.7964 24.4872 36.344 25.9177C34.8915 27.3483 32.9209 28.1548 30.8663 28.1548H15.7616V48H30.8663C34.4609 48 37.9095 46.5913 40.4495 44.0879C42.9931 41.5844 44.42 38.1869 44.42 34.6433V20.1408H44.4164L44.4127 20.1371Z"
            fill="url(#paint1_linear_1_105)"
          />
        </g>
        <path
          d="M67.3959 31.1627C64.5858 31.1627 62.1959 30.2435 60.2787 28.4051C58.3615 26.5405 57.416 24.1506 57.416 21.2354C57.416 18.2939 58.3877 15.8777 60.3312 13.9868C62.3009 12.0696 64.6646 11.1242 67.4484 11.1242C70.9414 11.1242 74.0929 12.7525 75.8 15.1949L73.3576 17.5323C71.7818 15.5626 69.8646 14.5909 67.606 14.5909C65.7939 14.5909 64.2444 15.2212 62.9837 16.4818C61.7494 17.7424 61.1191 19.3182 61.1191 21.2354C61.1191 23.1 61.7231 24.6496 62.9575 25.8839C64.1918 27.1183 65.7414 27.7223 67.5798 27.7223C69.9697 27.7223 71.9131 26.7506 73.4364 24.7809L75.9313 27.0395C74.1192 29.4819 70.9677 31.1627 67.3959 31.1627Z"
          fill="white"
        />
        <path
          d="M81.6193 30.8739H78.2051V10.9141H81.5405V18.4515C82.3547 17.1646 84.0355 16.2454 86.0577 16.2454C87.6073 16.2454 88.8941 16.7707 89.9709 17.7949C91.0477 18.8192 91.5992 20.2636 91.5992 22.1808V30.8739H88.185V23.1C88.185 20.7101 86.9507 19.3707 85.0598 19.3707C83.0375 19.3707 81.6193 20.9202 81.6193 23.1526V30.8739Z"
          fill="white"
        />
        <path
          d="M105.853 18.4252V16.6131H109.11V30.8739H105.853V29.1142C104.619 30.5062 103.069 31.2153 101.205 31.2153C99.1562 31.2153 97.4753 30.5062 96.1359 29.0617C94.7965 27.6173 94.1399 25.8051 94.1399 23.6778C94.1399 21.5505 94.7965 19.7647 96.1359 18.3727C97.4753 16.9808 99.1824 16.2717 101.205 16.2717C103.017 16.2717 104.566 16.9808 105.853 18.4252ZM105.932 23.7304C105.932 22.5223 105.538 21.498 104.75 20.6576C103.962 19.8172 102.964 19.397 101.73 19.397C100.496 19.397 99.4976 19.8172 98.7097 20.6576C97.9481 21.498 97.5541 22.5223 97.5541 23.7304C97.5541 24.9647 97.9481 25.989 98.7097 26.8294C99.4976 27.6698 100.496 28.09 101.73 28.09C102.964 28.09 103.962 27.6698 104.75 26.8294C105.538 25.989 105.932 24.9647 105.932 23.7304Z"
          fill="white"
        />
        <path
          d="M121.606 27.3546L122.683 30.0334C121.554 30.8213 120.162 31.2153 118.56 31.2153C115.33 31.2153 113.675 29.2981 113.675 25.6475V19.502H111.311V16.6131H113.728V11.5706H117.115V16.6131H121.895V19.502H117.115V25.5162C117.115 27.2233 117.798 28.09 119.19 28.09C119.978 28.09 120.792 27.8536 121.606 27.3546Z"
          fill="white"
        />
        <path
          d="M132.456 16.2717C134.479 16.2717 136.159 16.9808 137.499 18.4252C138.864 19.8697 139.547 21.6293 139.547 23.7566C139.547 25.8839 138.864 27.6435 137.499 29.088C136.159 30.5062 134.452 31.2153 132.43 31.2153C130.592 31.2153 129.068 30.4799 127.86 28.9829V30.8739H124.499V10.9141H127.913V18.4515C129.121 17.0071 130.644 16.2717 132.456 16.2717ZM136.054 23.7304C136.054 22.5223 135.66 21.498 134.899 20.6839C134.137 19.8434 133.165 19.4232 131.931 19.4232C130.697 19.4232 129.699 19.8434 128.937 20.6839C128.175 21.498 127.781 22.5223 127.781 23.7304C127.781 24.9647 128.175 25.989 128.937 26.8294C129.699 27.6435 130.697 28.0637 131.931 28.0637C133.165 28.0637 134.137 27.6435 134.899 26.8294C135.66 25.989 136.054 24.9647 136.054 23.7304Z"
          fill="white"
        />
        <path
          d="M147.883 26.2516L151.271 16.6131H155.001L149.223 31.7931C147.857 35.286 146.124 36.9406 143.419 36.9406C142.342 36.9406 141.449 36.7042 140.792 36.2577L141.344 33.3688C142.001 33.684 142.605 33.8416 143.156 33.8416C144.285 33.8416 145.231 33.0799 145.94 31.5304L146.281 30.7425L140.057 16.6131H144.023L147.883 26.2516Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1_105"
            x1="17.9402"
            y1="20.3744"
            x2="30.359"
            y2="32.5158"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop offset="0.76" stop-color="white" stop-opacity="0" />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1_105"
            x1="26.5053"
            y1="27.9468"
            x2="14.2982"
            y2="15.8017"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop offset="0.76" stop-color="white" stop-opacity="0" />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
          <clipPath id="clip0_1_105">
            <rect width="44.4163" height="48" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </a>

    <div className={`nav__elements ${menuOpen ? 'show-nav' : ''}`}>
        <ul className="nav__links">
          <li><a href="https://chatby.io/">Inicio</a></li>
          <li><a href="https://chatby.io/calculadora-precios-whatsapp-cloud/">Calculadora</a></li>
          <li><a href="https://chatby.io/pricing/">Precios</a></li>
        </ul>
        <ul className="nav__actions">
          <li>
            <a
              href="https://app.chatby.io/login"
              target="_blank"
              rel="noopener"
              className="button button--white button--small button--no-white-mobile"
            >Iniciar Sesión</a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener"
              className="button button--outlined button--small button--white-mobile"
              href={`https://chatby.io/register${localStorage.getItem('referedCode') ? `?ref=${localStorage.getItem('referedCode')}` : '?ref=Web'}`}
            >Registrarme</a>
          </li>
        </ul>
      </div>
    <button className="hambur-menu" onClick={toggleMenu}>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-6 h-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
        />
      </svg>
    </button>
  </nav>
  )
}

export default Nav
